import React, { useEffect, useState } from "react";
import api from "../../utils/axios.config";
import { baseUrl } from "../../utils/url";
import { BsTrashFill } from "react-icons/bs";
import { GrEdit } from "react-icons/gr";
import { toast } from "react-hot-toast";
import { useForm } from "react-hook-form";

function AddedHeaderBanner() {
  const [banners, setBanners] = useState([]);
  const [editingBanner, setEditingBanner] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();

  const handleGetHeaderBanners = async () => {
    const { data } = await api.get("header-banner");
    setBanners(data.data);
  };

  const handleDelete = async (id) => {
    if (window.confirm("আপনি কি নিশ্চিত যে আপনি এই ব্যানারটি মুছে ফেলতে চান?")) {
      try {
        setIsLoading(true);
        const { data } = await api.delete(`header-banner/${id}`);
        
        if (data.success) {
          toast.success(data.message);
          handleGetHeaderBanners();
        } else {
          toast.error(data.error);
        }
      } catch (error) {
        toast.error(error.response?.data?.error ?? error.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleEdit = (banner) => {
    setEditingBanner(banner);
    setValue("title", banner.title);
    setValue("description", banner.description);
  };

  const handleUpdate = async (formData) => {
    try {
      setIsLoading(true);
      const updateData = new FormData();
      
      if (formData.file && formData.file[0]) {
        updateData.append("image", formData.file[0]);
      }
      updateData.append("title", formData.title);
      updateData.append("description", formData.description);

      const { data } = await api.put(`header-banner/${editingBanner._id}`, updateData);
      
      if (data.success) {
        toast.success(data.message);
        setEditingBanner(null);
        reset();
        handleGetHeaderBanners();
      } else {
        toast.error(data.error);
      }
    } catch (error) {
      toast.error(error.response?.data?.error ?? error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelEdit = () => {
    setEditingBanner(null);
    reset();
  };

  useEffect(() => {
    handleGetHeaderBanners();
  }, []);
  return (
    <div className="space-y-6">
      {editingBanner && (
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-bold mb-4">ব্যানার সম্পাদনা করুন</h3>
          <form onSubmit={handleSubmit(handleUpdate)} className="space-y-4">
            <div>
              <label className="label">
                <span className="label-text">নতুন ছবি (ঐচ্ছিক)</span>
              </label>
              <input
                type="file"
                {...register("file")}
                className="file-input file-input-bordered file-input-primary w-full max-w-xs"
              />
            </div>
            
            <div className="form-control w-full max-w-xs">
              <label className="label">
                <span className="label-text">টাইটেল *</span>
              </label>
              <input
                {...register("title", { required: "টাইটেল আবশ্যক" })}
                type="text"
                placeholder="টাইটেল লিখুন"
                className="input input-bordered w-full max-w-xs"
              />
              <label className="label">
                <span className="label-text-alt text-red-500">
                  {errors.title && errors.title.message}
                </span>
              </label>
            </div>
            
            <div className="form-control w-full max-w-xs">
              <label className="label">
                <span className="label-text">বিবরণ *</span>
              </label>
              <textarea
                {...register("description", { required: "বিবরণ আবশ্যক" })}
                placeholder="বিবরণ লিখুন"
                className="textarea textarea-bordered w-full max-w-xs"
              />
              <label className="label">
                <span className="label-text-alt text-red-500">
                  {errors.description && errors.description.message}
                </span>
              </label>
            </div>
            
            <div className="flex space-x-4">
              <button
                type="submit"
                className="btn btn-primary text-white"
                disabled={isLoading}
              >
                {isLoading ? "আপডেট হচ্ছে..." : "আপডেট করুন"}
              </button>
              <button
                type="button"
                onClick={cancelEdit}
                className="btn btn-secondary"
                disabled={isLoading}
              >
                বাতিল
              </button>
            </div>
          </form>
        </div>
      )}
      
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="grid grid-cols-4 gap-4 p-4 bg-gray-50 font-semibold border-b">
          <p>ছবি</p>
          <p>টাইটেল</p>
          <p>বিবরণ</p>
          <p>অ্যাকশন</p>
        </div>
        
        {banners?.map((banner) => (
          <div
            key={banner._id}
            className="grid grid-cols-4 gap-4 p-4 items-center border-b hover:bg-gray-50"
          >
            <div className="avatar">
              <div className="w-16 h-16 rounded-lg overflow-hidden">
                <img
                  src={`${baseUrl}${banner.imageUrl}`}
                  alt={banner.title}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            
            <div>
              <p className="font-medium">{banner.title}</p>
            </div>
            
            <div>
              <p className="text-sm text-gray-600 truncate" title={banner.description}>
                {banner.description}
              </p>
            </div>
            
            <div className="flex space-x-2">
              <button
                onClick={() => handleEdit(banner)}
                className="btn btn-sm btn-outline btn-primary"
                disabled={isLoading || editingBanner}
                title="সম্পাদনা করুন"
              >
                <GrEdit size={16} />
              </button>
              <button
                onClick={() => handleDelete(banner._id)}
                className="btn btn-sm btn-outline btn-error"
                disabled={isLoading}
                title="মুছে ফেলুন"
              >
                <BsTrashFill size={16} />
              </button>
            </div>
          </div>
        ))}
        
        {banners?.length === 0 && (
          <div className="p-8 text-center text-gray-500">
            কোনো ব্যানার পাওয়া যায়নি
          </div>
        )}
      </div>
    </div>
  );
}

export default AddedHeaderBanner;
